import Head from 'next/head';
import type { NextPage } from 'next';
import { Image } from 'react-datocms';
import { renderMetaTags } from 'react-datocms';
import { withSession } from '@zopauk/nextjs-auth';
import { SimpleHero } from '@/components/SimpleHero';
import { useHubQuery } from '@/utils/dato/generated';
import { FlexContainer } from '@zopauk/react-components';
import { HubNavigation } from '@/components/HubNavigation';
import { HelpBackButton } from '@/components/HelpBackButton';
import { serverSideProps, HubContext } from '@/utils/models/hub';

const HubAllQuestions: NextPage<HubContext> = (context) => {
  const { data } = useHubQuery({ slug: context.slug });

  if (data?.hub) {
    const hub = data?.hub;

    return (
      <>
        <Head>{hub?.seo ? renderMetaTags(hub.seo.concat(data.site.favicon)) : null}</Head>
        <FlexContainer className="mt-8">
          <HelpBackButton />

          <SimpleHero
            image={
              hub.featuredImage?.responsiveImage ? (
                <Image
                  data={hub.featuredImage?.responsiveImage}
                  style={{ margin: '0 auto' }}
                  objectPosition="50% 50%"
                  priority={true}
                />
              ) : undefined
            }
            description="Find answers to our most frequently asked questions."
            title={hub.title || 'Untitled'}
          />

          <HubNavigation
            questions={hub.collections.flatMap((collection) => collection.questions)}
            collections={hub.collections}
            title="All"
            hub={hub}
          />
        </FlexContainer>
      </>
    );
  }

  return null;
};

export const getServerSideProps = serverSideProps;

export default withSession(HubAllQuestions, { forceLogin: false });
